import axios from "axios";

export const state = {
    dueloans: [],
};

export const getters = {
    dueloans: state => state.dueloans,
};

export const mutations = {
    setDueLoans(state, newValue) {
        state.dueloans = newValue
    },
};
 
export const actions = {
    async fetchDueLoans({ commit }) {
        await axios.get('/dueloans').then(res => {
            commit('setDueLoans', res.data.dueloans)
        })
    },
    filterDueLoans({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterdueloans";
        axios.post(url, formData).then((response) => {
            commit('setDueLoans', response.data.dueloans)
        })
    },
};
